<template>
<b-button class="ib sort-bt1"
    :size="size" :variant="buttonClass"
    @click="onButtonClick">
  <slot></slot>
  <i v-show="isSortStateNone" class="fa fa-sort"></i>
  <i v-show="isSortStateAsc"  class="fa" :class="sortAscIconName"></i>
  <i v-show="isSortStateDesc" class="fa" :class="sortDescIconName"></i>
</b-button>
</template>

<script>
import * as sortStates from '@/consts/sortStates'
export default {
  name: 'sort-button',
  props: {
    size: {
      type: String,
      default: 'sm',
    },
    variant: {
      type: String,
      default: 'success',
    },
    toggleType: {
      type: String,
      default: sortStates.TOGGLE_TYPE_NAD,
      validator: val => {
        const arr = [
          sortStates.TOGGLE_TYPE_NAD,
          sortStates.TOGGLE_TYPE_AD,
        ]
        return arr.indexOf(val) !== -1
      }
    },
    defaultState: {
      type: String,
      validator: val => {
        const arr = [
          sortStates.SORT_STATE_NONE,
          sortStates.SORT_STATE_ASC,
          sortStates.SORT_STATE_DESC,
        ]
        return arr.indexOf(val) !== -1
      }
    },
    iconType: {
      type: String,
      default: '',
      validator: val => {
        const arr = ['', 'amount', 'alpha', 'numeric']
        return arr.indexOf(val) !== -1
      }
    },
    bus: {
      type: Object,
    },
  },
  data() {
    const ret = {
      SORT_STATE_NONE: sortStates.SORT_STATE_NONE,
      SORT_STATE_ASC: sortStates.SORT_STATE_ASC,
      SORT_STATE_DESC: sortStates.SORT_STATE_DESC,
    }
    ret.toggleOrderArr = []
    if (this.toggleType === sortStates.TOGGLE_TYPE_NAD) {
      ret.toggleOrderArr = [
        ret.SORT_STATE_NONE,
        ret.SORT_STATE_ASC,
        ret.SORT_STATE_DESC,
      ]
    } else if (this.toggleType === sortStates.TOGGLE_TYPE_AD) {
      ret.toggleOrderArr = [
        ret.SORT_STATE_ASC,
        ret.SORT_STATE_DESC,
      ]
    }
    ret.currentSortState = this.defaultState || ret.toggleOrderArr[0]
    return ret
  },
  computed: {
    isSortStateNone() {
      return this.currentSortState === this.SORT_STATE_NONE
    },
    isSortStateAsc() {
      return this.currentSortState === this.SORT_STATE_ASC
    },
    isSortStateDesc() {
      return this.currentSortState === this.SORT_STATE_DESC
    },
    buttonClass() {
      let ret = this.variant
      if (this.isSortStateNone) {
        ret = 'outline-' + this.variant
      }
      return ret
    },
    sortAscIconName() {
      if (!this.iconType) { return 'fa-sort-asc' }
      return `fa-sort-${this.iconType}-asc`
    },
    sortDescIconName() {
      if (!this.iconType) { return 'fa-sort-desc' }
      return `fa-sort-${this.iconType}-desc`
    },
  },
  mounted() {
    this.setListeners()
  },
  methods: {
    setListeners() {
      if (!this.bus) { return }
      this.bus.$on('toDefaultState', () => {
        this.currentSortState =
          this.defaultState || this.toggleOrderArr[0]
      })
    },
    nextSortType() {
      const arr = this.toggleOrderArr
      const idx = arr.indexOf(this.currentSortState)
      const nextIdx = (idx + 1) % arr.length
      return arr[nextIdx]
    },
    onButtonClick() {
      this.currentSortState = this.nextSortType()
      this.$emit('sort', { sortState: this.currentSortState })
    }
  },
}
</script>

<style lang="scss">
.sort-bt1 {
  white-space: nowrap;
}
</style>
